import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DeviceUserManager } from './DeviceUserManager';
import { useNavigationHelpers } from '@/utils/navigationHelpers';

export const DeviceUserManagerWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { navigateWithTokenCheck } = useNavigationHelpers();

  if (!id) {
    return (
      <div className="min-h-screen bg-brand-white p-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-red-50 text-red-600 p-4 rounded-md">{t('errors.deviceNotFound')}</div>
          <button
            onClick={() => navigateWithTokenCheck(() => window.history.back(), '/devices')}
            className="mt-4 bg-brand-white text-brand-orange border border-brand-orange hover:bg-brand-orange hover:text-brand-white px-4 py-2 rounded-md transition-colors duration-200"
          >
            {t('common.goBack')}
          </button>
        </div>
      </div>
    );
  }

  return <DeviceUserManager deviceId={id} />;
};
